export const fmt = (value) =>
  value === null || value === undefined || value === "" ? "-" : String(value);

export const fmtDate = (value) =>
  value ? new Date(value).toLocaleString() : "-";

export const parseDecimalValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }

  const text = String(value).trim();
  if (!text) {
    return null;
  }

  const commaIndex = text.lastIndexOf(",");
  const dotIndex = text.lastIndexOf(".");

  let normalized = text;
  if (commaIndex > dotIndex) {
    normalized = normalized.replace(/\./g, "").replace(",", ".");
  } else if (dotIndex > commaIndex) {
    normalized = normalized.replace(/,/g, "");
  } else {
    normalized = normalized.replace(",", ".");
  }

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
};

export const formatDecimalPtBr = (value) => {
  if (!Number.isFinite(value)) {
    return null;
  }

  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);
};

export const toApiDateTime = (value) => {
  if (!value) return null;

  const parsed = value instanceof Date ? value : new Date(value);
  if (isNaN(parsed.getTime())) return null;

  const pad = (n) => String(n).padStart(2, "0");
  const yyyy = parsed.getFullYear();
  const mm = pad(parsed.getMonth() + 1);
  const dd = pad(parsed.getDate());
  const hh = pad(parsed.getHours());
  const mi = pad(parsed.getMinutes());
  const ss = pad(parsed.getSeconds());

  return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
};

export const mapFormToCreateApi = (values) => {
  const idCarga = values?.carga?.value || values?.carga?.Id || values?.idCarga;

  const asNumberOrNull = (inputValue) => {
    if (inputValue === "" || inputValue === null || inputValue === undefined) {
      return null;
    }

    const raw = typeof inputValue === "string" ? inputValue.replace(",", ".") : inputValue;
    const parsed = parseFloat(raw);
    return Number.isNaN(parsed) ? null : parsed;
  };

  const asIntegerOrNull = (inputValue) => {
    if (inputValue === "" || inputValue === null || inputValue === undefined) {
      return null;
    }

    const parsed = parseInt(inputValue, 10);
    return Number.isNaN(parsed) ? null : parsed;
  };

  return {
    NumeroDoPedido: values?.numeroDoPedido,
    IdCarga: idCarga ? parseInt(idCarga, 10) : null,
    LocalPalletizacao: values?.localPalletizacao || "",
    DataAgendamento: toApiDateTime(values?.dataAgendamento),
    DataIntegracao: toApiDateTime(new Date()),

    NumeroDePallets: asNumberOrNull(values?.numeroDePallets),
    PesoLiquido: asNumberOrNull(values?.pesoLiquido),
    TipoDeRemetente: values?.tipoDeRemetente || null,
    NumeroPedidoEmbarcador: values?.numeroPedidoEmbarcador || null,
    DataColeta: toApiDateTime(values?.dataColeta),
    Remetente: values?.remetente || null,
    Destinatario: values?.destinatario || null,
    Origem: values?.origem || null,
    Destino: values?.destino || null,
    TipoDeCarga: values?.tipoDeCarga || null,
    TipoDeOperacao: values?.tipoDeOperacao || null,
    Rota: values?.rota || null,
    EmpresaFilial: values?.empresaFilial || null,
    ModeloVeicularSolicitado: values?.modeloVeicularSolicitado || null,
    DataPrevisaoSaida: toApiDateTime(values?.dataPrevisaoSaida),
    DataPrevisaoEntregaRemetente: toApiDateTime(values?.dataPrevisaoEntregaRemetente),
    DataInicialViagemExecutada: toApiDateTime(values?.dataInicialViagemExecutada),
    DataFinalViagemExecutada: toApiDateTime(values?.dataFinalViagemExecutada),
    DataInicialViagemFaturada: toApiDateTime(values?.dataInicialViagemFaturada),
    DataFinalViagemFaturada: toApiDateTime(values?.dataFinalViagemFaturada),
    Tomador: values?.tomador || null,
    PesoDoPedido: asNumberOrNull(values?.pesoDoPedido),
    QuantidadeDeEntrega: asIntegerOrNull(values?.quantidadeDeEntrega),
    DataAgendamentoPedido: toApiDateTime(values?.dataAgendamentoPedido),
    CondicaoDoPedido: values?.condicaoDoPedido || null,
    ObservacaoPedido: values?.observacaoPedido || null,
  };
};
